import {
  forwardRef,
  type ReactNode,
  type Ref,
  type ComponentProps,
} from 'react';
import * as React from 'react';
import clsx from 'clsx';
import styles from './TransparentButton.module.css';

type Props = {
  testid?: string;
  className?: string;
  ariaLabel?: string;
  type?: ComponentProps<'button'>['type'];
  ariaExpanded?: boolean;
  ariaControls?: string;
  children?: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  autoFocus?: boolean;
  disabled?: boolean;
  onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
};

/**
 * Not technically a Ramen component. Putting here because it's used by Ramen (and prolifically across other packages).
 * This avoids circular dependencies.
 */
export const TransparentButton = forwardRef(
  (props: Props, ref: Ref<HTMLButtonElement>) => {
    const {
      type,
      ariaControls,
      ariaExpanded,
      testid,
      className,
      ariaLabel,
      children,
      onClick,
      autoFocus,
      disabled,
      onKeyDown,
    } = props;
    return (
      <button
        type={type}
        ref={ref}
        aria-controls={ariaControls}
        aria-expanded={ariaExpanded}
        autoFocus={autoFocus}
        data-testid={testid}
        className={clsx(className, styles.button)}
        onClick={onClick}
        aria-label={ariaLabel ?? ''}
        disabled={disabled}
        onKeyDown={onKeyDown}
      >
        {children}
      </button>
    );
  }
);
